import { useTranslation } from "react-i18next";
import InvoiceOperate from "../components/invoice-operate";
import InvoiceRecord from "../components/invoice-record";
import { InoviceTabType } from "../constants";
import { useInvoiceStore } from "../store/invoice-store";

export function useGetTabsList() {
  const { setCurrentInvoiceTab, currentInvoiceTab } = useInvoiceStore();
  const { t } = useTranslation("invoice");
  const currentTabsList = [
    {
      label: t("invoice_make_invoice"),
      key: InoviceTabType.BiilableRecord,
      children: <InvoiceOperate />,
    },
    {
      label: t("invoice_biling_record"),
      key: InoviceTabType.BilledRecord,
      children: <InvoiceRecord />,
    },
  ];
  return { tabsList: currentTabsList, setCurrentInvoiceTab, currentInvoiceTab };
}
